/* icons
* ----------------------------------
*/
// RegExp to require all (.icons-) assets in './icons'-directory.
var iconsContext = require.context( "./icons", true, /\.(svg)$/ );
if ( iconsContext.length >= 0 ) {
	iconsContext.keys().forEach( function ( key ) {
		iconsContext( key );
	});
}

/* fonts
* ----------------------------------
*/
// RegExp to require all (.fonts-) assets in './fonts'-directory.
var fontsContext = require.context( "./fonts", true, /\.woff(2)?|ttf|eot$/ );
if ( fontsContext.length >= 0 ) {
	fontsContext.keys().forEach( function ( key ) {
		fontsContext( key );
	});
}

/* img
* ----------------------------------
*/
// RegExp to require all (.img-) assets in './img'-directory.
var imgContext = require.context( "./img", true, /\.(png|gif|jpg|svg)$/ );
if ( imgContext.length >= 0 ) {
	imgContext.keys().forEach( function ( key ) {
		imgContext( key );
	});
}

/* CSS
* ----------------------------------
*/
require('./css/base.css'); // All other css assets are imported in this file

/* JS
* ----------------------------------
*/
// RegExp to require all (.js-) assets in './js'-directory.
var jsContext = require.context( "./js", true, /\.js$/ );
if ( jsContext.length >= 0 ) {
	jsContext.keys().forEach( function ( key ) {
		jsContext( key );
	});
}